import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import supabase from '../supabase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSiteLang as useLang } from '../siteLang'; 
import '../design-system.css';

const t = {
    fr: { confirming: 'Confirmation en cours...', success: 'Inscription confirmée', successBody: 'Merci ! Tu recevras désormais nos nouvelles.', fail: 'Lien invalide', failBody: 'Ce lien de confirmation est invalide ou a déjà été utilisé.' },
    en: { confirming: 'Confirming...', success: 'Subscription confirmed', successBody: 'Thanks! You\'ll now receive our updates.', fail: 'Invalid link', failBody: 'This confirmation link is invalid or has already been used.' },
    vi: { confirming: 'Đang xác nhận...', success: 'Đã xác nhận đăng ký', successBody: 'Cảm ơn! Bạn sẽ nhận được thông tin cập nhật.', fail: 'Liên kết không hợp lệ', failBody: 'Liên kết xác nhận này không hợp lệ hoặc đã được sử dụng.' },
};

function ConfirmNewsletter() {
    const [searchParams] = useSearchParams();
    const { lang } = useLang();
    const copy = t[lang] || t.fr;
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const confirm = async () => {
            const email = searchParams.get('email');
            const token = searchParams.get('token');
            if (!email || !token) { setStatus('fail'); return; }

            const { data, error } = await supabase.functions.invoke('confirm-newsletter', { body: { email, token } });
            if (error || !data?.confirmed) { setStatus('fail'); return; }
            setStatus('success');
        };
        confirm();
    }, [searchParams]);

    return (
        <div className="w-page">
            <Navbar variant="light" />
            <div className="w-body" style={{ maxWidth: '440px', textAlign: 'center', paddingTop: '80px' }}>
                {status === 'loading' && <p className="w-subtitle">{copy.confirming}</p>}
                {status === 'success' && (
                    <>
                        <h1 className="w-title">{copy.success}</h1>
                        <p className="w-subtitle">{copy.successBody}</p>
                    </>
                )}
                {status === 'fail' && (
                    <>
                        <h1 className="w-title">{copy.fail}</h1>
                        <p className="w-subtitle">{copy.failBody}</p>
                    </>
                )}
            </div>
            <Footer variant="light" />
        </div>
    );
}

export default ConfirmNewsletter;